module.exports = __webpack_public_path__ + "img/beijing13.9f09dddd.jpg";